import { Modal, Box, Typography, Button, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { MdErrorOutline } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { hideErrorModal } from "../../../Infrastructure/States/errorModalSlice";
import { errorModalSx } from "./styles";

export const ErrorModal = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isOpen, errorMessage, redirectPath } = useSelector((state) => state.errorModal);

  const handleClose = () => {
    dispatch(hideErrorModal());
    if (redirectPath) navigate(redirectPath);
  };
  return (
    <Modal
      open={isOpen}
      disableScrollLock
      onClose={handleClose}
      aria-labelledby="error-modal-title"
      aria-describedby="error-modal-description"
      sx={errorModalSx.modal}
      BackdropProps={{ sx: errorModalSx.backdrop }}
    >
      <Box sx={errorModalSx.container}>
        <Box sx={errorModalSx.contentBox}>
          <MdErrorOutline style={{...errorModalSx.icon, color: theme.palette.primary.main,}} />
          <Typography variant="h5" color="primary" sx={errorModalSx.title}>
            Oops! Something went wrong.
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={errorModalSx.message}>
            {errorMessage}
          </Typography>
          <Button variant="contained" color="primary" sx={errorModalSx.button} onClick={handleClose}>
            {redirectPath ? "Go Back" : "Close"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
